import User from "@/entity/User";

export interface ComparatorStore {
    itemTypes: any,
    propertyTypes: any,
    items: any,
    properties: any,
    assetContainerExpanded: any
    assetModal: any
}

const state: ComparatorStore = {
    itemTypes: {},
    propertyTypes: {},
    items: {},
    properties: {},
    assetContainerExpanded: null,
    assetModal: null
}

const mutations = {
    setUser(state: ComparatorStore, user: User) {
        // state.user = user
    },
}

const actions = {
    login({commit}: any, user: User) {
        commit('setUser', user)
    },
    async resetResponse({commit, state}: any, payload: any) {
        await commit("resetResponse", payload);
    },
}

const getters = {
    // isLoggedIn: (state: ComparatorStore) => !!state.user
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
